import { apiUrl } from './../constants/apiUrl';
import api from '../service/apiService';
// import { Utils } from '../util/utils';
// import { errorAction } from './errorAction'
import { logKafka, logOtherInfo, detailsInfo, catchJSException } from './../service/logService';
import { getVZDLInit } from './../service/vzdl';

let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;

export const getFaqFromJSON = (dispatch) => {
  var response = require('../containers/product/sampleFaqJson.json');
  dispatch({ type: 'FAQFROMJSON', value: response.FaqData });
  return response;
};
export const getFaqFromApi = (visitId, dispatch) => {
  try {
    logOtherInfo(detailsInfo('FaqPage', visitId, 'faqpage', 'faq page'));
    // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Updating your cart" } });
    const faqUrl = apiUrl().faqUrl;
    return new Promise((resolve, reject) => {
      api(faqUrl, 'GET')
        .then((response) => {
          window.scrollTo(0, 0);
          dispatch({ type: 'FAQFROMAPI', value: response.description });
          // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
          resolve(response);
        })
        .catch((error) => {
          let errorMsg = `MethodName:faqpage,errorMessage:${error.message}`;
          logKafka('ERROR', 'faqPage', errorMsg, getErrorLogUrl, 'applogs', visitId);
          getVZDLInit(visitId, '', '', '', '', '', '', error.message);
          // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        });
    });
  } catch (ex) {
    catchJSException('FaqPage', visitId, 'faq', ex);
  }
};
